export default __webpack_public_path__ + "static/1_1-3dbcdd6a59de3039caf271b824cd6e36.jpeg";